import * as b3js from 'brandseyejs';
import {
    formatCurrency,
    formatNumber,
    formatPercentage,
    simpleGetterFactory,
    simpleSetterFactory,
    tagAndTopicDescriptionGetterFactory,
    tagAndTopicFilterGetterFactory,
    tagAndTopicRawDataGetterFactory,
    tagAndTopicRawDataSetterFactory,
    tagAndTopicSetterFactory,
} from "@/dashboards/widgets/fantasticchart/FantasticUtilities";

export default {
    "totalAdSpend": {
        name: "Ad Spend",
        chartName: "Ad Spend",
        yLabel: {long: "Ad Spend", short: "Ad Spend"},
        defaultSortOptions: {label: "Ad Spend", field: "totalAdSpend", order: "descending"},
        formatY: formatCurrency,
        setter: simpleSetterFactory("totalAdSpend"),
        getter: simpleGetterFactory("totalAdSpend"),
    },
    "totalAdCpc": {
        name: "Cost per click (CPC)",
        chartName: "Cost per click",
        yLabel: {long: "Cost per click (CPC)", short: "CPC"},
        defaultSortOptions: {label: "Cost per click (CPC)", field: "totalAdCpc", order: "descending"},
        formatY: formatCurrency,
        setter: simpleSetterFactory("totalAdCpc"),
        getter: simpleGetterFactory("totalAdCpc"),
    },
    "totalAdCpm": {
        name: "Cost per mille (CPM)",
        chartName: "Cost per mille",
        yLabel: {long: "Cost per mille (CPM)", short: "CPM"},
        defaultSortOptions: {label: "Cost per mille (CPM)", field: "totalAdCpm", order: "descending"},
        formatY: formatCurrency,
        setter: simpleSetterFactory("totalAdCpm"),
        getter: simpleGetterFactory("totalAdCpm"),
    },
    "totalAdCostPerPageEngagement": {
        name: "Cost per Page Engagement",
        chartName: "Cost per Page Engagement",
        yLabel: {long: "Cost per Page Engagement", short: "Cost/Page Eng"},
        defaultSortOptions: {label: "Cost per Page Engagement", field: "totalAdCostPerPageEngagement", order: "descending"},
        formatY: formatCurrency,
        setter: simpleSetterFactory("totalAdCostPerPageEngagement"),
        getter: simpleGetterFactory("totalAdCostPerPageEngagement"),
    },
    "totalAdCostPerPostEngagement": {
        name: "Cost per Post Engagement",
        chartName: "Cost per Post Engagement",
        yLabel: {long: "Cost per Post Engagement", short: "Cost/Post Eng"},
        defaultSortOptions: {label: "Cost per Post Engagement", field: "totalAdCostPerPostEngagement", order: "descending"},
        formatY: formatCurrency,
        setter: simpleSetterFactory("totalAdCostPerPostEngagement"),
        getter: simpleGetterFactory("totalAdCostPerPostEngagement"),
    },
    "totalAdCostPerLinkClick": {
        name: "Cost per Link Click",
        chartName: "Cost per Link Click",
        yLabel: {long: "Cost per Link Click", short: "Cost/Link Click"},
        defaultSortOptions: {label: "Cost per Link Click", field: "totalAdCostPerLinkClick", order: "descending"},
        formatY: formatCurrency,
        setter: simpleSetterFactory("totalAdCostPerLinkClick"),
        getter: simpleGetterFactory("totalAdCostPerLinkClick"),
    },
    "totalAdClicks": {
        name: "Clicks",
        chartName: "Ad Clicks",
        yLabel: {long: "Ad Clicks", short: "Clicks"},
        defaultSortOptions: {label: "Ad Clicks", field: "totalAdClicks", order: "descending"},
        formatY: formatNumber,
        formatLabel: formatNumber,
        setter: simpleSetterFactory("totalAdClicks"),
        getter: simpleGetterFactory("totalAdClicks"),
    },
    "totalAdCtr": {
        name: "Clickthrough rate (CTR)",
        chartName: "Clickthrough rate",
        yLabel: {long: "Clickthrough Rate (CTR)", short: "CTR"},
        defaultSortOptions: {label: "Clickthrough rate (CTR)", field: "totalAdCtr", order: "descending"},
        formatY: (d) => formatPercentage(d * 100, 2),
        setter: simpleSetterFactory("totalAdCtr"),
        getter: simpleGetterFactory("totalAdCtr"),
    },
    "totalAdOutboundClicks": {
        name: "Outbound Clicks",
        chartName: "Outbound Clicks",
        yLabel: {long: "Outbound Clicks", short: "Outbound Clicks"},
        defaultSortOptions: {label: "Outbound Clicks", field: "totalAdOutboundClicks", order: "descending"},
        formatY: formatNumber,
        formatLabel: formatNumber,
        setter: simpleSetterFactory("totalAdOutboundClicks"),
        getter: simpleGetterFactory("totalAdOutboundClicks"),
    },
    "totalAdOutboundClicksCtr": {
        name: "Outbound Clickthrough rate (Outbound CTR)",
        chartName: "Outbound Clickthrough rate",
        yLabel: {long: "Outbound Clickthrough Rate (Outbound CTR)", short: "Outbound CTR"},
        defaultSortOptions: {label: "Outbound CTR", field: "totalAdOutboundClicksCtr", order: "descending"},
        formatY: (d) => formatPercentage(d * 100, 2),
        setter: simpleSetterFactory("totalAdOutboundClicksCtr"),
        getter: simpleGetterFactory("totalAdOutboundClicksCtr"),
    },
    "totalAdInlineLinkClicks": {
        name: "Link Clicks",
        chartName: "Link Clicks",
        yLabel: {long: "Link Clicks", short: "Link Clicks"},
        defaultSortOptions: {label: "Link Clicks", field: "totalAdInlineLinkClicks", order: "descending"},
        formatY: formatNumber,
        formatLabel: formatNumber,
        setter: simpleSetterFactory("totalAdInlineLinkClicks"),
        getter: simpleGetterFactory("totalAdInlineLinkClicks"),
    },
    "totalAdInlineLinkClickCtr": {
        name: "Link Clickthrough rate (Link CTR)",
        chartName: "Link Clickthrough rate",
        yLabel: {long: "Link Clickthrough Rate (Link CTR)", short: "Link CTR"},
        defaultSortOptions: {label: "Link CTR", field: "totalAdInlineLinkClickCtr", order: "descending"},
        formatY: (d) => formatPercentage(d * 100, 2),
        setter: simpleSetterFactory("totalAdInlineLinkClickCtr"),
        getter: simpleGetterFactory("totalAdInlineLinkClickCtr"),
    },
    "totalAdImpressions": {
        name: "Ad Impressions",
        chartName: "Ad Impressions",
        yLabel: {long: "Ad Impressions", short: "Impressions"},
        defaultSortOptions: {label: "Ad Impressions", field: "totalAdImpressions", order: "descending"},
        formatY: formatNumber,
        formatLabel: formatNumber,
        setter: simpleSetterFactory("totalAdImpressions"),
        getter: simpleGetterFactory("totalAdImpressions"),
    },
    "totalAdFrequency": {
        name: "Ad Frequency",
        chartName: "Ad Frequency",
        yLabel: {long: "Ad Frequency", short: "Frequency"},
        defaultSortOptions: {label: "Ad Frequency", field: "totalAdFrequency", order: "descending"},
        formatY: (d) => formatNumber(d, 2),
        setter: simpleSetterFactory("totalAdFrequency"),
        getter: simpleGetterFactory("totalAdFrequency"),
    },
    "totalAdReach": {
        name: "Ad Reach",
        chartName: "Ad Reach",
        yLabel: {long: "Ad Reach", short: "Reach"},
        defaultSortOptions: {label: "Ad Reach", field: "totalAdReach", order: "descending"},
        formatY: formatNumber,
        formatLabel: formatNumber,
        setter: simpleSetterFactory("totalAdReach"),
        getter: simpleGetterFactory("totalAdReach"),
    },
    // X-axis (groupBy) fields for advertising
    "adCampaignName": {
        name: "Campaign name",
        isTag: true,
        tagNamespace: "advertisement-campaign",
        grouseAlias: ["tag"],
        scaleX: b3js.scaleDiscrete,
        noLimit: true,
        hideUnknown: true,
        getter: simpleGetterFactory("adCampaignName.name"),
        setter: tagAndTopicSetterFactory("adCampaignName"),
        filterGetter: tagAndTopicFilterGetterFactory("adCampaignName"),
        filterField: "tag",
        rawDataGetter: tagAndTopicRawDataGetterFactory("adCampaignName"),
        rawDataSetter: tagAndTopicRawDataSetterFactory("adCampaignName"),
        extendData: function (d) {
            if (d && d.namespace === "advertisement-campaign") {
                return {
                    "adCampaignName.id": d.id,
                    "adCampaignName.name": d.name,
                    "adCampaignName.namespace": d.namespace
                };
            }
            return d;
        },
        preProcess: function (data, model) {
            // When comparing with another isTag field, swap tag and tag2 so the
            // compare field stays in tag2 as expected.
            const compare = model.get("compare");
            if (compare && compare !== "adCampaignName") {
                data.forEach(d => {
                    if (d.tag && d.tag2) {
                        const clone = JSON.parse(JSON.stringify(d));
                        d.tag = clone.tag2;
                        d.tag2 = clone.tag;
                    }
                });
            }
            return data;
        },
        descriptionGetter: tagAndTopicDescriptionGetterFactory("adCampaignName"),
    },
    "adSetName": {
        name: "Ad set name",
        isTag: true,
        tagNamespace: "advertisement-adset",
        grouseAlias: ["tag"],
        scaleX: b3js.scaleDiscrete,
        noLimit: true,
        hideUnknown: true,
        getter: simpleGetterFactory("adSetName.name"),
        setter: tagAndTopicSetterFactory("adSetName"),
        filterGetter: tagAndTopicFilterGetterFactory("adSetName"),
        filterField: "tag",
        rawDataGetter: tagAndTopicRawDataGetterFactory("adSetName"),
        rawDataSetter: tagAndTopicRawDataSetterFactory("adSetName"),
        extendData: function (d) {
            if (d && d.namespace === "advertisement-adset") {
                return {
                    "adSetName.id": d.id,
                    "adSetName.name": d.name,
                    "adSetName.namespace": d.namespace
                };
            }
            return d;
        },
        preProcess: function (data, model) {
            const compare = model.get("compare");
            if (compare && compare !== "adSetName") {
                data.forEach(d => {
                    if (d.tag && d.tag2) {
                        const clone = JSON.parse(JSON.stringify(d));
                        d.tag = clone.tag2;
                        d.tag2 = clone.tag;
                    }
                });
            }
            return data;
        },
        descriptionGetter: tagAndTopicDescriptionGetterFactory("adSetName"),
    },
    "adName": {
        name: "Ad name",
        isTag: true,
        tagNamespace: "advertisement-ad",
        grouseAlias: ["tag"],
        scaleX: b3js.scaleDiscrete,
        noLimit: true,
        hideUnknown: true,
        getter: simpleGetterFactory("adName.name"),
        setter: tagAndTopicSetterFactory("adName"),
        filterGetter: tagAndTopicFilterGetterFactory("adName"),
        filterField: "tag",
        rawDataGetter: tagAndTopicRawDataGetterFactory("adName"),
        rawDataSetter: tagAndTopicRawDataSetterFactory("adName"),
        extendData: function (d) {
            if (d && d.namespace === "advertisement-ad") {
                return {
                    "adName.id": d.id,
                    "adName.name": d.name,
                    "adName.namespace": d.namespace
                };
            }
            return d;
        },
        preProcess: function (data, model) {
            const compare = model.get("compare");
            if (compare && compare !== "adName") {
                data.forEach(d => {
                    if (d.tag && d.tag2) {
                        const clone = JSON.parse(JSON.stringify(d));
                        d.tag = clone.tag2;
                        d.tag2 = clone.tag;
                    }
                });
            }
            return data;
        },
        descriptionGetter: tagAndTopicDescriptionGetterFactory("adName"),
    },
};
